import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungDortmund() {
  return (
    <CityPageTemplate
      city="Dortmund"
      slug="dortmund"
      intro="Im Ruhrgebiet setzt FINABLE auf digitale, unabhängige Beratung ohne Umwege."
      description="Unabhängige & digitale Finanzberatung für Dortmund: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
